// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2d-0";